export const LISTE_CONTRAT_NATURE = {
  title: 'Liste des natures de bail',
  actions: {
    add: 'Ajouter une nature de bail',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
  },
  tab: {
    libelle: 'Libellé',
    emplacement: 'Emplacement',
    valeurParDefaut: 'Valeur par défaut',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_CONTRAT_NATURE = {
  titleAdd: 'Ajouter une nature de bail',
  titleEdit: 'Modifier une nature de bail',
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    contratNatureOneDefautValue: 'Il existe déjà une valeur par défaut dans vos natures de bail',
  },
  informationContratNature: {
    libelle: 'Libellé',
    emplacement: 'Emplacement',
    valeurParDefaut: 'Valeur par défaut',
  },
  success: {
    add: 'La nature de bail a été ajoutée avec succès.',
    edit: 'La nature de bail a été modifiée avec succès.',
  },
};
